// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"c8d2900d","351":"3bc6c2d6","964":"26cfe8c6"}[chunkId] + ".chunk.js";
};